import * as React from 'react';
import {useNavigate} from 'react-router-dom'
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCube  } from '@fortawesome/free-solid-svg-icons';
library.add(faCube)

export default function ShowBoxBreadcrumbs(props) {
    const searchParams = (new URLSearchParams(window.location.search)).get("parent")
    const parentId = searchParams && searchParams.replace(/perpetual/g, ""). replace(/-/g, ' ');
    const navigate = useNavigate();
    return (
        <Breadcrumbs
            aria-label="breadcrumb"
            pt={3}
            separator={<NavigateNextIcon fontSize="small" />}
        >
            <Link style={{ textDecoration: 'none' }} color="primary" href="/">
            <FontAwesomeIcon style={{ color: '#1784e8', marginRight: 5 }} icon={faCube}  /> Showboxes
            </Link>
            <Link onClick={() => navigate(-1)} style={{ cursor:"pointer",textDecoration: 'none' }} color="primary">
            <FontAwesomeIcon style={{ color: '#1784e8', marginRight: 5 }} icon={faCube}  /><span style={{textTransform: "capitalize"}}>{parentId}</span>
            </Link>
            <Typography underline="hover" color="text.primary">{props.categoryTitle}</Typography>
        </Breadcrumbs>
    );
}